import { useAsyncEffect } from 'ahooks'
import { useMemo, useState } from 'react'

import { openWebview } from '@docs/common'
import { getCommunityTopicDetail } from 'common/request'
import { getCommunityAvator, getInfoFromTopicHtml, isQa } from 'common/util'

import { DOMAINS } from 'common/constant'
import styles from './index.module.scss'

const ACTIVITIES_ID = 16 // 17
const MAX_SHOW_LEN = 3

interface IProps {
  id: number
  befortrigger: () => void
}

const openCommunityLink = (topic?: ITopicDetail) => {
  if (!topic || !topic.id) {
    return
  }
  if ((window as any).__IS_APP__) {
    openWebview(`https://security-app-community${isQa() ? '-qa' : ''}.eufylife.com/topic/${topic.id}`)
  } else {
    window.location.href = `${DOMAINS.discourse[isQa() ? 'qa' : 'pr']}/t/${topic.slug}/${topic.id}`
  }
}

const Community = ({ id, befortrigger }: IProps) => {
  const [topic, setTopic] = useState<ITopicDetail>()

  const originPost = useMemo(() => topic?.post_stream.posts[0], [topic?.post_stream])

  const { images, digest } = useMemo(() => getInfoFromTopicHtml(originPost?.cooked), [originPost])

  // 是否是 Activities 帖子，大图模式
  const isActivities = useMemo(() => topic?.category_id === ACTIVITIES_ID, [topic?.category_id])

  // 开启多图模式
  const isSingleImageMode = useMemo(
    () => images.length >= 1 && images.length < MAX_SHOW_LEN && !isActivities,
    [images, isActivities]
  )

  const openLink = () => {
    befortrigger && befortrigger()
    openCommunityLink(topic)
  }

  useAsyncEffect(async () => {
    const data = await getCommunityTopicDetail(id)
    setTopic(data)
  }, [id])

  return (
    <div className={styles.community} onClick={openLink}>
      <div className={isSingleImageMode ? styles.single : ''}>
        <div className={styles.text}>
          <h3 className={styles.title}>{topic?.title}</h3>

          {digest && !isActivities && <p className={styles.digest}>{digest}</p>}
        </div>
        {isSingleImageMode && (
          <div
            className={styles.image}
            data-rest={images.length > 1 ? `+ ${images.length - 1}` : undefined}
            style={{ backgroundImage: `url(${images[0].src})` }}
          ></div>
        )}
      </div>

      {isActivities && images?.[0] && (
        <div className={styles.banner} style={{ backgroundImage: `url(${images[0].src})` }}></div>
      )}

      {digest && isActivities && <p className={styles.digest}>{digest}</p>}

      {/*  */}
      {!isActivities && images.length >= 3 && (
        <div className={styles.wraper}>
          {images.slice(0, MAX_SHOW_LEN).map((item, i) => (
            <div
              key={i}
              className={styles.image}
              data-rest={i === MAX_SHOW_LEN - 1 ? `+ ${images.length - MAX_SHOW_LEN}` : undefined}
              style={{ backgroundImage: `url(${item.src})` }}
            ></div>
          ))}
        </div>
      )}

      {/*  */}
      {!isActivities && (
        <div className={styles.message}>
          <div className={styles.user}>
            <i style={{ backgroundImage: `url(${getCommunityAvator(originPost?.avatar_template || '')})` }}></i>
            <span>{originPost?.username}</span>
          </div>
          <div className={styles.data}>
            <div className={styles.views}>{topic?.views || 0}</div>
            <div className={styles.likes}>{topic?.like_count || 0}</div>
            <div className={styles.replys}>{topic?.posts_count || 0}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Community
